import { render, staticRenderFns } from "./CorrelationDiagramDialog.vue?vue&type=template&id=1f0822a4&scoped=true"
import script from "./CorrelationDiagramDialog.vue?vue&type=script&lang=ts"
export * from "./CorrelationDiagramDialog.vue?vue&type=script&lang=ts"
import style0 from "./CorrelationDiagramDialog.vue?vue&type=style&index=0&id=1f0822a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0822a4",
  null
  
)

export default component.exports